import React from 'react'
import { Modal, Button } from '@sainsburys-tech/fable'
import { PropTypes } from 'prop-types'

const AlreadySignedInModal = (props) => {
  const {
    isOpen, title, details, okClick
  } = props

  return (
    <Modal
      header={{
        label: title,
        isDismissible: false,
      }}
      isOpen={isOpen}
      onClose={okClick}
      hasClickawayClose={false}
      renderFooter={(
        <Button type="button" variant="primary" isFullWidth onClick={okClick}>
          Ok
        </Button>
      )}
    >
      <p>{details}</p>
    </Modal>
  )
}

AlreadySignedInModal.propTypes = {
  isOpen: PropTypes.bool,
  title: PropTypes.string.isRequired,
  details: PropTypes.string.isRequired,
  okClick: PropTypes.func.isRequired
}

AlreadySignedInModal.defaultProps = {
  isOpen: false
}

export default AlreadySignedInModal
